import FileUploadInputComponent from "../../components/file/file-upload-input.component";
import DataInputModel from "../../models/data-input/data-input.model";
import ViewBase from "../view-base.view";

export default function DataInputView() {
  ViewBase.call(this);

  let dataInputTypes = [];
  let selectedInputType = null;
  let selectedSaleType = null;
  let fileData = null;
  let uploadedResult = null;
  let configDataInput = null;

  let inputFileRef = null;

  let id = "data-upload-view";

  function handleInputTypeRadioChange(value) {
    selectedInputType = value;
    selectedSaleType = null;
    fileData = null;
    uploadedResult = null;
    inputFileRef.value = "";

    document.querySelector(`#${id}-sale-type-heading > button`).click();
  }

  function handleSaleTypeRadioChange(value) {
    selectedSaleType = dataInputTypes.find((item) => item.code === value);
    fileData = null;
    uploadedResult = null;
    inputFileRef.value = "";

    document.querySelector(`#${id}-input-upload-heading > button`).click();
  }

  const handleDownloadExcelTemplate = () => {
    if (selectedSaleType) {
      this.showLoading();
      const promiseRes = DataInputModel.downloadExcelTemplate(selectedSaleType?.code,
        `${selectedInputType}_${selectedSaleType?.saleType}_Template`
      );
      promiseRes
        .catch((error) => this.handleError(error))
        .finally(() => {
          this.hideLoading();
        });
    }
  };

  function handleUploadInputChange(data) {
    fileData = data;
  }

  const handleUpload = () => {
    if (fileData && selectedSaleType) {
      this.showLoading();
      const bodyFormData = new FormData();
      bodyFormData.append("uploadedFile", fileData);
      DataInputModel.uploadExcel(bodyFormData, selectedSaleType?.code)
        .then((data) => {
          uploadedResult = data;
        })
        .catch((error) => this.handleError(error))
        .finally(() => {
          this.hideLoading();
        });
    }
  };

  const handleClickDownloadResult = (fileId, filename) => {
    this.showLoading();
    DataInputModel.downloadResult(fileId, filename)
      .catch(err => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      })
  }

  function fetchConfigDataInput() {
    return DataInputModel.getConfigDataInput();
  }

  function getConvertedConfigDataInput(configDataInput) {
    const dataInputList = configDataInput?.data ?? [];
    return dataInputList.map((d) => {
      const [code, dataType, saleType] = d.split("^^");
      return { code, dataType, saleType };
    });
  }

  function getDataTypes(dataInputTypes = []) {
    let dataTypes = new Set();
    for (let item of dataInputTypes) {
      dataTypes.add(item.dataType);
    }
    return Array.from(dataTypes);
  }

  function getSaleTypes(dataInputTypes = [], selectedInputType) {
    return dataInputTypes.filter((item) => item.dataType === selectedInputType);
  }

  function renderDataInputTypes(list = []) {
    return list.map((inputType) =>
      m(".form-check.form-check-inline",
        {
          onchange: (e) => handleInputTypeRadioChange(e.target.value),
          key: inputType,
        },
        m(`input.form-check-input#${id}-${inputType}[type=radio][name=${id}-data-type-radio][value=${inputType}]`
        ),
        m(`label.form-check-label[for=${id}-${inputType}]`, inputType)
      )
    );
  }

  function renderSaleTypes(list = []) {
    return list.map((item) =>
      m(".form-check.form-check-inline",
        {
          onchange: (e) => handleSaleTypeRadioChange(e.target.value),
          key: item.code,
        },
        m(`input.form-check-input#${id}-${item.code}[type=radio][name=${id}-sale-type-radio][value=${item.code}]`
        ),
        m(`label.form-check-label[for=${id}-${item.code}]`, item.saleType)
      )
    );
  }

  return {
    oninit: () => {
      this.showLoading();
      fetchConfigDataInput()
        .then((data) => {
          configDataInput = data;
          dataInputTypes = getConvertedConfigDataInput(configDataInput);
        })
        .catch((error) => this.handleError(error))
        .finally(() => {
          this.hideLoading();
        });
    },

    oncreate: () => {
      const inputFile = document.querySelector("#data-upload-view-input-file");
      if (inputFile) {
        inputFileRef = inputFile;
      }
    },

    view: () => {
      return [
        m(".card.mb-3",
          m(".card-body",
            m(`.accordion#${id}-accordion`,
              m(".accordion-item",
                m(`h2.accordion-header#${id}-data-type-heading`,
                  m(`button.accordion-button[type=button][data-bs-toggle=collapse][data-bs-target=#${id}-data-type-collapse][aria-expanded=true][aria-controls=${id}-data-type-collapse]`,
                    m("span", this.getText("LT00000013", "Data Type")),
                    m("span.ms-5", selectedInputType)
                  )
                ),
                m(`.accordion-collapse.collapse.show#${id}-data-type-collapse[aria-labelledby=${id}-data-type-heading][data-bs-parent=#${id}-accordion]`,
                  m(".accordion-body",
                    renderDataInputTypes(getDataTypes(dataInputTypes))
                  )
                )
              ),
              m(".accordion-item",
                m(`h2.accordion-header#${id}-sale-type-heading`,
                  m(`button.accordion-button.collapsed[type=button][data-bs-toggle=collapse][data-bs-target=#${id}-sale-type-collapse][aria-expanded=false][aria-controls=${id}-sale-type-collapse]`,
                    m("span", this.getText("LT00000791", "Sale Type")),
                    m("span", { class: "ms-5" }, selectedSaleType?.saleType)
                  )
                ),
                m(`.accordion-collapse.collapse#${id}-sale-type-collapse[aria-labelledby=${id}-sale-type-heading][data-bs-parent=#${id}-accordion]`,

                  m(".accordion-body",
                    renderSaleTypes(getSaleTypes(dataInputTypes, selectedInputType)
                    )
                  )
                )
              ),
              m(".accordion-item",
                m(`h2.accordion-header#${id}-input-upload-heading`,
                  m(`button.accordion-button.collapsed[type=button][data-bs-toggle=collapse][data-bs-target=#${id}-input-upload-collapse][aria-expanded=false][aria-controls=${id}-input-upload-collapse]`,
                    m("span", this.getText("LT00000792", "File Upload"))
                  )
                ),
                m(`.accordion-collapse.collapse#${id}-input-upload-collapse[aria-labelledby=${id}-input-upload-heading][data-bs-parent=#${id}-accordion]`,
                  m(".accordion-body",
                    m(".row",
                      m(".col-lg-6",
                        m(FileUploadInputComponent, {
                          id: `${id}-input-file`,
                          disabled: !selectedSaleType,
                          accept: ".xlsx,.xls",
                          onTemplateDownloadClick: handleDownloadExcelTemplate,
                          onInput: handleUploadInputChange,
                        })
                      ),
                      m(".col-12",
                        m(".text-end.mt-2",
                          m("button.btn.btn-primary",
                            {
                              onclick: handleUpload,
                              disabled: !selectedSaleType || !fileData,
                            },
                            this.getText("LT00000290", "Upload")
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),

        uploadedResult &&
        m(".card",
          m(".card-body",
            m('ul.list-group',
              m("li.list-group-item.d-flex.align-items-center.justify-content-between",
                m("span",
                  `${this.getText("LT00000794",
                    "Total Record(s) Inserted"
                  )}: ${uploadedResult?.successCount}`
                ),
                m('button.btn.btn-primary', { style: "right:50px;", onclick: () => handleClickDownloadResult(uploadedResult?.successFileGUID, `inserted_${uploadedResult?.successFileGUID}`) }, m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000492", "Download"))
              ),

              m("li.list-group-item.d-flex.align-items-center.justify-content-between",
                m("span",
                  `${this.getText("LT00000795",
                    "Total Record(s) Rejected"
                  )}: ${uploadedResult?.rejectedCount}`
                ),
                m('button.btn.btn-primary', { style: "right:50px;", onclick: () => handleClickDownloadResult(uploadedResult?.rejectedFileGUID, `rejected_${uploadedResult?.rejectedFileGUID}`) }, m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000492", "Download"))
              ),
            )
          )
        ),
        this.getBaseViews(),
      ];
    },
  };
}
